(function () {
  var PHONE_CLASS = 'header-phone-sticky';
  var PHONE_TEL   = '+15147816450';
  var PHONE_LABEL = '514-781-6450';
  var SCROLL_THRESHOLD = 100; // px avant d'afficher le bouton
  var PHONE_HTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="15" height="15" style="margin-right:6px;vertical-align:middle">' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" ' +
    'd="M3.5 4.5c0-.5.4-1 1-1h2l1.5 3.5-1.5 1c.6 1.5 1.5 2.8 3 3.5l1-1.5 3.5 1.5v2c0 .6-.5 1-1 1C6.5 18 2 13.5 2 7.5c0-.5.4-1 1-1z"/>' +
    '</svg>' + PHONE_LABEL;

  function injectStyle() {
    if (document.getElementById('header-phone-sticky-style')) return;
    var style = document.createElement('style');
    style.id = 'header-phone-sticky-style';
    style.textContent =
      // État par défaut : caché (invisible mais prend pas la place)
      '.' + PHONE_CLASS + '{' +
        'display:inline-flex;align-items:center;justify-content:center;' +
        'white-space:nowrap;text-decoration:none;' +
        'padding-block:10px !important;' +
        'opacity:0;visibility:hidden;pointer-events:none;' +
        'transform:translateY(-8px);' +
        'transition:opacity .25s ease, transform .25s ease, visibility .25s ease;' +
        'max-width:0;margin-inline:0;padding-inline:0 !important;' +
        'overflow:hidden; color: #fff;' +
      '}' +
      // État scrollé : visible
      '.' + PHONE_CLASS + '.is-visible{' +
        'opacity:1;visibility:visible;pointer-events:auto;' +
        'transform:translateY(0);' +
        'max-width:300px;' +
        'padding-inline:24px !important;' +
        'margin-inline-end:8px;' +
      '}' +
      // Caché sur mobile peu importe le scroll
      '@media (max-width:749px){.' + PHONE_CLASS + '{display:none !important}}';
    document.head.appendChild(style);
  }

  function addPhone() {
    injectStyle();

    var rightCol = document.querySelector('.header__column--right');
    if (!rightCol) return;
    if (rightCol.querySelector('.' + PHONE_CLASS)) return;

    var a = document.createElement('a');
    a.href = 'tel:' + PHONE_TEL;
    a.className = PHONE_CLASS + ' size-style button';
    a.setAttribute('style',
      '--size-style-width: fit-content;' +
      '--size-style-height: ;' +
      '--size-style-width-mobile: fit-content;' +
      '--size-style-width-mobile-min: fit-content;'
    );
    a.innerHTML = PHONE_HTML;

    var anchor = rightCol.querySelector('search-button')
              || rightCol.querySelector('.dropdown-localization')
              || rightCol.firstElementChild;

    if (anchor) {
      rightCol.insertBefore(a, anchor);
    } else {
      rightCol.appendChild(a);
    }

    // Applique immédiatement l'état en fonction du scroll actuel
    updateVisibility();
  }

  // ────── Gestion du scroll ──────
  var ticking = false;
  function updateVisibility() {
    var btn = document.querySelector('.' + PHONE_CLASS);
    if (!btn) return;
    if (window.scrollY > SCROLL_THRESHOLD) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
  }
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        updateVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  // ────── Déclencheurs ──────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addPhone);
  } else {
    addPhone();
  }

  window.addEventListener('pagereveal', addPhone);
  window.addEventListener('pageshow', addPhone);
  document.addEventListener('shopify:section:load', addPhone);
  document.addEventListener('shopify:section:reorder', addPhone);

  var header = document.querySelector('#header-component, .header-section');
  if (header) {
    new MutationObserver(function () {
      if (!document.querySelector('.' + PHONE_CLASS)) addPhone();
    }).observe(header, { childList: true, subtree: true });
  }
})();